// extracted by mini-css-extract-plugin
module.exports = {"layout":"speaker-card-cms_layout__vc4Jl","photoContainer":"speaker-card-cms_photoContainer__V5Cla","photo":"speaker-card-cms_photo__JwdEV"};